export default "__VITE_ASSET__B8jZG6RQ__"